import React, { useState, useEffect } from "react"
import { Tabs, Image, Carousel } from 'antd';
import classes from './styles.module.css'
import i18next from "i18next"
import { useTranslation } from "react-i18next"
import ReactPlayer from 'react-player/lazy'; 
import { SampleNextArrow, SamplePrevArrow } from '../../../common/ArrowsForCarousel'
import cookies from "js-cookie";

interface Props {
  Pointid: any,
  Pointinfo: any,
  PointThumb: any,
  VoiceMp3: any,
  PointGallery: any,
  Bibliography: any,
  Point3d: any,
  Point360: any,
  Collection: any
}

const ComponentTabs: React.FC<Props> = ({ Pointid, Pointinfo, VoiceMp3, PointGallery, Bibliography, Point360, Point3d }) => {
  const { t } = useTranslation()
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [pois, setPois] = useState([]);
  const [showPreview, setShowPreview] = useState(false)
  const [isActive, setIsActive] = useState(true);
  const [ActiveID, setActiveID] = useState();
  const [Activeimg, setActiveimg] = useState();
  const [Activename, setActivename] = useState();
  const [Activeinfo, setActiveinfo] = useState();

  let activecategory = '';
  if (Pointid == '1_1')
    activecategory = '2';
  else if (Pointid == '1_318')
    activecategory = '21';
  else if (Pointid == '1_313')
  activecategory = '19';
  var currentLanguageCode = cookies.get("i18next") || "el";

  function openPoint(point: any, img: any, name: any, info: any) {
    setIsActive(current => !current);
    setActiveID(point);
    setActiveimg(img);
    setActivename(name);
    setActiveinfo(info)
  }

  const getCategoryPois = async () => {
    const url = `https://dimosapokoronou.mitos.cityguideplatform.com/api/pois?category_id=${activecategory}&lang=${currentLanguageCode}`
    const response = await fetch(url,
      {
        signal,
        headers: {
          'X-API-KEY': 'OHiqSkWShHTbMGLoB5Am',
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
    if (!response.ok) {
      throw new Error('Data could not be fetched!')
    }
    else {

      return response.json()
    }
  };

  useEffect(() => {
    //Handle Responsiveness  
    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    handleResize()

    // Bind the event listener
    window.addEventListener('resize', handleResize)

    return () => {
      // Unbind the event listener on clean up
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    getCategoryPois()
      .then((res1) => {
        // console.log(res1);
        setPois(res1.success)
      })
      .catch((e) => {
        console.log(e.message)
      })
  }, [i18next.language])

  const controller = new AbortController();
  const { signal } = controller;

  const settingsCarousel = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1056,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        }
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  const items1 = []
  
  items1.push({
    label: 
      <div>
        <span>
          <span style={{ fontSize: '36px', border: 'none' }}>
            <img src="/img/tabicons/description.png" />
          </span>
        </span>
        {width > 992 && <b>{t("Περιγραφή")}</b>}
      </div>,
    key: '1',
    children:
      <div>
       <h2 className={classes.title}>{t("Περιγραφή")}</h2>
        {VoiceMp3.map((mp: any) => {
          return (
            <ReactPlayer className={classes.soundBar} width={'100%'} height={'50px'} controls url={mp.url} />
          )
        })}
          <div className={classes.p} dangerouslySetInnerHTML={{ __html: Pointinfo }} />
      </div>
  })

  {
    PointGallery.length > 1 &&
      items1.push({
        label: 
          <div>
            <span>
              <span style={{ fontSize: '36px', border: 'none' }}>
                <img src="/img/tabicons/photos.png" />
              </span>
            </span>
            {width > 992 && <b>{t("Φωτογραφίες")}</b>}
          </div>,
        key: '2',
        children:
          <div>
            {width > 992 &&  <h2 className={classes.title}>{t("Φωτογραφίες")}</h2>}
            <Image.PreviewGroup>

              {PointGallery.map((image: any) => {
                return (
                  <span className={classes.pimg}>
                    <Image src={image.url}/>
                  </span>
                )
              })}
            </Image.PreviewGroup>
          </div>
      })
  }

  {(Pointid == '1_1') &&
    items1.push({
      label: 
        <div>
          <span>
            <span style={{ fontSize: '36px', border: 'none' }}>
              <img src="/img/tabicons/doc.png" />
            </span>
          </span>
          {width > 992 && <b>{t("Εκθέματα")}</b>}
        </div>,
      key: '6',
      children:
        <div>
          <h2 className={classes.title}>{t("Εκθέματα")}</h2>
          {pois.map((poi: any) => {
            return (
              <span className={classes.pimg}>
                <Image 
                  src={poi.main_image}
                  preview={{
                    destroyOnClose: true,
                    imageRender: () => (
                      <div className={classes.exhibitContainer}>
                        <img src={poi.main_image} />
                        <div className={classes.exhibitInfoContainer}>
                          <span>
                            <h2>{poi.name}</h2>
                            {/* <button>X</button> */}
                          </span>
                          <p dangerouslySetInnerHTML={{__html: poi.portal_main_info}}></p>
                        </div>
                      </div>
                    ),
                    toolbarRender: () => null,
                    }}
                />
              </span>
            )
          })}
        </div>
      })}

  {
    Point360 &&
      items1.push({
        label: 
          <div>
            <span>
              <span style={{ fontSize: '36px', border: 'none' }}>
                <img src="/img/tabicons/360.png" />
              </span>
            </span>
            {width > 992 && <b>360<sup>o</sup></b>}
          </div>,
        key: '3',
        children:
          <div>
            <h2 className={classes.title}>{t("Εικονικό Πανόραμα")} 360<sup>o</sup></h2>
            {Pointid == '1_340' &&
              <div>
                <iframe src='/360/1.html' width="100%" height="480px" scrolling="no" ></iframe>
              </div>
            }
          </div>
      })
  }
  {
    Point3d &&
      items1.push({
        label: 
          <div>
            <span>
              <span style={{ fontSize: '36px', border: 'none' }}>
                <img src="/img/tabicons/3d.png" />
              </span>
            </span>
            {width > 992 && <b>3D</b>}
        </div>,
        key: '4',
        children:
          <div>
            <h2 className={classes.title}>{t("3D Μοντέλο")}</h2>
            {Pointid == '1_313' && <div className={classes.sketchfab_embed}> <iframe title="Kara Musa Pasha Cami, Καρά Μουσά Τζαμί-Ρέθυμνο" allowFullScreen allow="autop1lay; fullscreen; xr-spatial-tracking" xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share src="https://sketchfab.com/models/a5c26546541e45b09a2718ab8f943efc/embed?autostart=1&dnt=1"> </iframe> </div>}
            {Pointid == '1_340' && <div className={classes.sketchfab_embed}> <iframe title="Kara Musa Pasha Cami, Καρά Μουσά Τζαμί-Ρέθυμνο" allowFullScreen allow="autoplay; fullscreen; xr-spatial-tracking" xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share src="https://sketchfab.com/models/64f12e67cd444f6f98641323ae7f9199/embed?autostart=1&dnt=1"> </iframe> </div>}
            {Pointid == '1_339' && Pointid == '1_337' && Pointid == '1_338' && Pointid == '1_328' && Pointid == '1_339' && Pointid == '1_329' && <div className={classes.sketchfab_embed}> <iframe title="Kara Musa Pasha Cami, Καρά Μουσά Τζαμί-Ρέθυμνο" allowFullScreen allow="autoplay; fullscreen; xr-spatial-tracking" xr-spatial-tracking execution-while-out-of-viewport execution-while-not-rendered web-share src="https://sketchfab.com/models/bf5156372a3343c1a74e514cca5247fb/embed?autostart=1&dnt=1"> </iframe> </div>}
          </div>
      })
  }
  {
    Bibliography &&
      items1.push({
        label: 
          <div>
            <span> 
              <span style={{ fontSize: '36px', border: 'none' }}>
                <img src="/img/tabicons/bibliography.png" />
              </span>
            </span>
            {width > 992 && <b>{t("Βιβλιογραφία")}</b>}
          </div>,
        key: '5',
        children:
          <div style={{minHeight: '22.15rem'}}>
            <h2 className={classes.title}>{t("Βιβλιογραφία")}</h2>
            <div className={classes.p} dangerouslySetInnerHTML={{ __html: Bibliography }} />
          </div>
      })
  }

  return (
    <Tabs
      defaultActiveKey="1"
      centered
      tabBarStyle={{ color: 'black', outlineOffset: 'none' }}
      items={items1}
    />
  )
}

export default ComponentTabs